'use client';

import { c as _c } from "react/compiler-runtime";
import { Card, Stack, Typography } from '@mui/material';
import { Provider, ResourceType } from '@repo/api-gw-sdk';
import { CloudProviderIndicator } from '@/components/cloudProviderIndicator';
import { useResourceIdentifiers } from '@/components/queryBuilder/useResourceIentifiers';
import { Loader } from '@/components/shared/loader';

// A Google Workspace backup policy targets exactly one workspace resource,
// stored in the policy's include list (no condition, no excludes — see
// validateGoogleWorkspacePolicy on the backend). The generic scope viewer would
// render that as "All resources are excluded" + a faceless "Included: 1"
// counter, so GWS gets this dedicated viewer that names the targeted workspace.
export const GwsResourceSelectionViewer = t0 => {
  const $ = _c(12);
  const {
    resourceId
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [Provider.GoogleWorkspace];
    t2 = [ResourceType.GoogleWorkspaceResource];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const {
    data,
    isLoading
  } = useResourceIdentifiers(t1, t2, undefined, true);
  let t3;
  if ($[2] !== data?.resources || $[3] !== resourceId) {
    t3 = data?.resources?.find(r => r.providerId === resourceId);
    $[2] = data?.resources;
    $[3] = resourceId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const resource = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      width: "auto",
      border: "1px solid var(--mui-palette-divider)",
      padding: "24px",
      backgroundColor: "transparent"
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      gap: "16px"
    };
    t6 = <Typography variant="subtitle1">This backup policy applies to the following Google Workspace:</Typography>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isLoading || $[9] !== resource || $[10] !== resourceId) {
    t7 = <Card sx={t4}><Stack sx={t5}>{t6}{isLoading ? <Loader size="medium" /> : resource ? <CloudProviderIndicator cloudProvider={resource.cloudProvider} text={resource.name} /> : <CloudProviderIndicator cloudProvider={Provider.GoogleWorkspace} text={resourceId} />}</Stack></Card>;
    $[8] = isLoading;
    $[9] = resource;
    $[10] = resourceId;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};